import { ReportsAPI } from '@/src/api';
import { useApiClient } from '@/src/hooks/api/useApiClient';
import { useTranslation } from 'react-i18next';

export const useReportsApi = () => {
  const { t } = useTranslation();

  return new ReportsAPI(useApiClient(), t);
};
